import React, { useEffect, useRef } from 'react';
import './CartoonAuth.css';

interface CatMascotProps {
  message: string;
  isPeeking?: boolean;
  isCoveringEyes?: boolean;
}

export const CatMascot: React.FC<CatMascotProps> = ({ message, isPeeking, isCoveringEyes }) => {
  const catRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (isCoveringEyes) return;
      if (!catRef.current) return;

      const pupils = catRef.current.querySelectorAll('.pupil');
      pupils.forEach((pupil) => {
        const p = pupil as HTMLElement;
        const eye = p.parentElement;
        if (!eye) return;
        const eyeRect = eye.getBoundingClientRect();
        const eyeCenterX = eyeRect.left + eyeRect.width / 2;
        const eyeCenterY = eyeRect.top + eyeRect.height / 2;

        const angle = Math.atan2(e.clientY - eyeCenterY, e.clientX - eyeCenterX);
        const maxDistance = 10;
        const distance = Math.min(maxDistance, Math.hypot(e.clientX - eyeCenterX, e.clientY - eyeCenterY) / 8);

        const pupilX = Math.cos(angle) * distance;
        const pupilY = Math.sin(angle) * distance;

        p.style.transform = `translate(calc(-50% + ${pupilX}px), calc(-50% + ${pupilY}px))`;
      });
    };

    document.addEventListener('mousemove', handleMouseMove);
    return () => document.removeEventListener('mousemove', handleMouseMove);
  }, [isCoveringEyes]);

  return (
    <div className="cat-container" ref={catRef}>
      <div className="cat-message" style={{ opacity: message ? 1 : 0 }}>{message || '喵~'}</div>
      <div className={`cat ${isCoveringEyes ? 'covering-eyes' : ''} ${isPeeking ? 'peeking' : ''}`}>
        <div className="ear ear-left"></div>
        <div className="ear ear-right"></div>
        <div className="cat-face">
          <div className="eyes-container">
            <div className="eye">
              <div className="pupil"></div>
            </div>
            <div className="eye">
              <div className="pupil"></div>
            </div>
          </div>
          <div className="nose"></div>
          <div className="mouth"></div>
          <div className="whiskers whiskers-left">
            <div className="whisker"></div>
            <div className="whisker"></div>
            <div className="whisker"></div>
          </div>
          <div className="whiskers whiskers-right">
            <div className="whisker"></div>
            <div className="whisker"></div>
            <div className="whisker"></div>
          </div>
          <div className="blush blush-left"></div>
          <div className="blush blush-right"></div>
        </div>
        <div className="paw paw-left">
          <div className="paw-pad paw-toe paw-toe-1"></div>
          <div className="paw-pad paw-toe paw-toe-2"></div>
          <div className="paw-pad paw-toe paw-toe-3"></div>
          <div className="paw-pad paw-main"></div>
        </div>
        <div className="paw paw-right">
          <div className="paw-pad paw-toe paw-toe-1"></div>
          <div className="paw-pad paw-toe paw-toe-2"></div>
          <div className="paw-pad paw-toe paw-toe-3"></div>
          <div className="paw-pad paw-toe paw-toe-4"></div>
          <div className="paw-pad paw-main"></div>
        </div>
        <div className="tail"></div>
      </div>
    </div>
  );
};
